import React from 'react';
import { ReactComponent as Pain1to2 } from './pain1-2.svg';
import { ReactComponent as Pain3to4 } from './pain3-4.svg';
import { ReactComponent as Pain5to6 } from './pain5-6.svg';
import { ReactComponent as Pain7to8 } from './pain7-8.svg';
import { ReactComponent as Pain9to10 } from './pain9-10.svg';

export const PainEmoji1to2 = () => <Pain1to2 />;

export const PainEmoji3to4 = () => <Pain3to4 />;

export const PainEmoji5to6 = () => <Pain5to6 />;

export const PainEmoji7to8 = () => <Pain7to8 />;

export const PainEmoji9to10 = () => <Pain9to10 />;
